import useLanguage from "../../../../../hooks/useLanguage";

export default function PageLock() {
  const { t } = useLanguage();

  return (
    <main className="grid min-h-screen place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-gray-600">{t("yourmedias-erro")} 403</p>
        <h1 className="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
          {t("yourmedias-erro-titulo")}
        </h1>
        <p className="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
          {t("yourmedias-lock-desc")}
        </p>
      </div>
    </main>
  )
}
